import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../assets/css/Form.css';
import logo from '../assets/images/Logo.svg';
import check from '../assets/images/check.svg';
import axios from 'axios';

function EmailVerified() {
	let navigate = useNavigate();

	const { token } = useParams();

	useEffect(() => {
		axios.post(
			`http://ec2-3-13-248-4.us-east-2.compute.amazonaws.com/email-verify/${token}`
		);
	});

	const handleEmail = e => {
		e.preventDefault();
		navigate(`/login`);
	};

	return (
		<div className='main-container form-bg-color form-bg-log'>
			<img src={logo} className='form-logo' alt='logo' />
			<div className='form-container'>
				<img
					src={check}
					style={{
						height: '7vmin',
						pointerEvents: 'none',
						marginBottom: '7px',
					}}
					alt='logo'
				/>
				<div className='form-label2-vmn'>Success!</div>
				<span
					style={{
						color: '#000',
						'font-size': '14px',
						margin: '10px 0px',
						display: 'block',
					}}
				>
					Your email address is now verified..
				</span>
				<button type='submit' onClick={handleEmail} className='btn-send-code'>
					GO TO LOGIN
				</button>
			</div>
		</div>
	);
}

export default EmailVerified;
